<form [formGroup]="form" class="form-container">
  <mat-form-field appearance="fill" class="form-subject" *ngFor="let field of getDynamicFields()">
    <mat-label>{{ field.label?.[getCurrentLanguage()] }}</mat-label>
    <input [type]="field.formValueType" matInput [formControlName]="field.code">
  </mat-form-field>
</form>